var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 124,
    viewBox: "0 0 122 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8341 54.5167L23.9013 55.5694C23.9013 55.5694 23.6135 58.4402 27.0759 58.4402H38.2113",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6837 22.3158V24.5263C79.6837 24.5263 79.6837 25.5789 74.6387 26.2105L67.5988 27.1674L59.6189 28.2583",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8967 63.4067C82.8967 63.4067 87.8553 63.4067 89.9942 63.4067C90.7615 63.4067 93.9458 63.4067 94.8857 62.8421C96.2093 62.0957 95.7009 59.9713 95.7009 58.1722",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5072 120.938C54.0943 117.77 57.221 114.785 57.4608 109.694C57.7006 104.603 57.8157 93.5407 57.8157 93.5407V44.622C57.8157 43.9043 47.2654 38.1627 47.2654 38.1627",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1176 19.4832V122.22",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9768 44.4402C73.9768 44.4402 73.9768 49.6459 73.9768 51.9617C73.9768 54.2775 62.947 54.8325 62.947 58.0957C62.947 61.7703 62.947 106.124 62.947 110.593C62.947 115.062 69.4786 121.416 69.4786 121.416",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.622 70.2488V76.4402C73.622 76.4402 65.7092 80.1052 65.2297 80.5837C64.7501 81.0622 65.2297 105.627 65.2297 107.856C65.2297 110.086 76.8159 119.426 76.8159 119.426",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7667 66.89V76.6794L54.7369 82.1244V109.215C54.7369 111.005 44.1003 119.828 44.1003 119.828",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0256 66.9091C51.8195 66.9091 55.7056 63.0317 55.7056 58.2488C55.7056 53.4658 51.8195 49.5885 47.0256 49.5885C42.2318 49.5885 38.3456 53.4658 38.3456 58.2488C38.3456 63.0317 42.2318 66.9091 47.0256 66.9091Z",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8341 54.5263C25.9635 54.5263 27.6898 52.804 27.6898 50.6794C27.6898 48.5548 25.9635 46.8325 23.8341 46.8325C21.7047 46.8325 19.9785 48.5548 19.9785 50.6794C19.9785 52.804 21.7047 54.5263 23.8341 54.5263Z",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4552 38.4497C48.9948 38.4497 52.6748 34.778 52.6748 30.2488C52.6748 25.7195 48.9948 22.0478 44.4552 22.0478C39.9156 22.0478 36.2355 25.7195 36.2355 30.2488C36.2355 34.778 39.9156 38.4497 44.4552 38.4497Z",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8303 4.85591C51.748 6.37189 51.1115 8.2266 51.1115 10.2297C51.1115 15.3508 55.2725 19.5024 60.4053 19.5024C65.5382 19.5024 69.6992 15.3508 69.6992 10.2297C69.6992 8.1225 68.9947 6.1795 67.808 4.62231",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.406 70.4689C79.5483 70.4689 82.9063 67.1185 82.9063 62.9856C82.9063 58.8527 79.5483 55.5024 75.406 55.5024C71.2636 55.5024 67.9056 58.8527 67.9056 62.9856C67.9056 67.1185 71.2636 70.4689 75.406 70.4689Z",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9769 44.4497C77.9232 44.4497 81.1223 41.2579 81.1223 37.3206C81.1223 33.3832 77.9232 30.1914 73.9769 30.1914C70.0305 30.1914 66.8314 33.3832 66.8314 37.3206C66.8314 41.2579 70.0305 44.4497 73.9769 44.4497Z",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6837 22.3158C81.8555 22.3158 83.6161 20.5592 83.6161 18.3923C83.6161 16.2255 81.8555 14.4689 79.6837 14.4689C77.5119 14.4689 75.7513 16.2255 75.7513 18.3923C75.7513 20.5592 77.5119 22.3158 79.6837 22.3158Z",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1038 58.0766C98.853 58.0766 101.082 55.853 101.082 53.1101C101.082 50.3671 98.853 48.1436 96.1038 48.1436C93.3546 48.1436 91.126 50.3671 91.126 53.1101C91.126 55.853 93.3546 58.0766 96.1038 58.0766Z",
    stroke: "#EFC519",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 122.086C93.6299 122.086 120.082 95.6945 120.082 63.1387C120.082 30.583 93.6299 4.19138 61 4.19138C28.37 4.19138 1.91821 30.583 1.91821 63.1387C1.91821 95.6945 28.37 122.086 61 122.086Z",
    stroke: "#EFC519",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 124,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUx);
export default __webpack_public_path__ + "static/media/ux.166561e14a7832e570448c74f56a3cbd.svg";
export { ForwardRef as ReactComponent };